import { message, Layout, ConfigProvider, Breadcrumb, Table, DatePicker, Select, AutoComplete, Button, Form, Col, Row, Input, Card, Checkbox } from 'antd';
import esES from 'antd/lib/locale/es_ES';
import React, { useState, useEffect } from 'react';
import reqwest from 'reqwest';
import moment from 'moment';
import 'antd/dist/antd.css';
import '../Billing/index.css';
import MyMenu from '../../components/Menu';
import { getToken } from '../../Utils/common';
import { useHistory } from 'react-router-dom';
import config from '../../config';

const { Content, Sider, Header } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

moment.locale('es');

function BillingMedications() {
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);
  const [active, setActive] = useState(0);

  const [medicalInsurances, setMedicalInsurances] = useState([]);

  const [medReportLoading, setMedReportLoading] = useState(false);
  const [medReportData, setMedReportData] = useState([]);
  const [medReportSummary, setMedReportSummary] = useState(null);
  const [medPacientOptions, setMedPacientOptions] = useState([]);
  const [medPacientText, setMedPacientText] = useState('');
  const [medGroupByMedication, setMedGroupByMedication] = useState(false);
  const [medFilters, setMedFilters] = useState({
    start: moment(),
    end: moment(),
    pacient: null,
    medical_insurance: null,
  });

  useEffect(() => {
    fetchMedicalInsurances('');
  }, []);

  const fetchMedicalInsurances = (params = {}, props) => {
    if (params) params = `&search=${params}`;
    reqwest({
      url: `${config.api_url}/medicalinsurance/?limit=1000${params}`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    })
      .then(data => {
        const medicalinsurances_data = data.results.map(user => ({
          text: `${user.short_name}`,
          value: user.id,
        }));
        setMedicalInsurances(medicalinsurances_data);
      })
      .catch(errorInfo => {
        if (errorInfo.status == 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else {
          message.error(`Ha ocurrido un error al intentar obtener las obras sociales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        }
      });
  };

  const onCollapse = collapsed => {
    setCollapsed(prev => !prev);
  };

  // Medication billing helpers
  const searchPacientsForMed = (q) => {
    if (!q) { setMedPacientOptions([]); return; }
    reqwest({
      url: `${config.api_url}/pacients/?limit=20&search=${encodeURIComponent(q)}`,
      method: 'get', type: 'json', headers: { 'Authorization': `Token ${getToken()}` }
    }).then(data => {
      const opts = (data.results || []).map(p => ({ value: String(p.id), label: `${p.name} ${p.last_name} (${p.id})` }));
      setMedPacientOptions(opts);
    }).catch(() => {});
  };

  const runMedicationReport = () => {
    if (!medFilters.start || !medFilters.end) { message.warning('Seleccione un rango de fechas'); return; }
    // Require medical insurance when grouping by medication
    if (medGroupByMedication && !medFilters.medical_insurance) {
      message.warning('Seleccione una obra social para agrupar por medicamento');
      return;
    }
    // Clear previous data so the spinner/skeleton is visible and old data doesn't linger
    setMedReportData([]);
    setMedReportSummary(null);
    setMedReportLoading(true);
    const params = new URLSearchParams();
    params.set('start_date', moment(medFilters.start).format('YYYY-MM-DD 00:00'));
    params.set('end_date', moment(medFilters.end).format('YYYY-MM-DD 23:59'));
    if (medFilters.pacient) params.set('pacient', medFilters.pacient);
    if (medFilters.medical_insurance) params.set('medical_insurance', medFilters.medical_insurance);
    if (medGroupByMedication) params.set('group_by', 'medication');
    reqwest({
      url: `${config.api_url}/billing/medications?${params.toString()}`,
      method: 'get', type: 'json', headers: { 'Authorization': `Token ${getToken()}` }
    }).then(resp => {
      const results = resp.results || [];
      let rows = [];
      if (medGroupByMedication) {
        rows = results.map((m, idx) => ({
          key: `med-${m.medication_id}-${idx}`,
          medication_name: m.medication_name,
          intakes: m.intakes,
          total_dose: m.total_dose,
        }));
      } else {
        results.forEach(p => {
          (p.medications || []).forEach(m => {
            rows.push({
              key: `${p.pacient_id}-${m.medication_id}`,
              pacient_id: p.pacient_id,
              pacient_name: p.pacient_name,
              obra_social: (p.medical_insurance && (p.medical_insurance.short_name || p.medical_insurance.name)) || '-',
              medication_name: m.medication_name,
              intakes: m.intakes,
              total_dose: m.total_dose,
            });
          });
        });
      }
      setMedReportData(rows);
      setMedReportSummary(resp.summary || null);
    }).catch(err => {
      const code = (err && err.status) || '';
      message.error(`Error obteniendo reporte de medicación ${code}`);
    }).always(() => setMedReportLoading(false));
  };

  const medColumnsPatient = [
    { title: 'Paciente', dataIndex: 'pacient_name', key: 'pacient_name' },
    { title: 'Obra Social', dataIndex: 'obra_social', key: 'obra_social' },
    { title: 'Medicamento', dataIndex: 'medication_name', key: 'medication_name' },
    { title: 'Tomas', dataIndex: 'intakes', key: 'intakes' },
    { title: 'Dosis total', dataIndex: 'total_dose', key: 'total_dose' },
  ];

  const medColumnsByMedication = [
    { title: 'Medicamento', dataIndex: 'medication_name', key: 'medication_name' },
    { title: 'Tomas', dataIndex: 'intakes', key: 'intakes' },
    { title: 'Dosis total', dataIndex: 'total_dose', key: 'total_dose' },
  ];

  const exportMedicationReport = () => {
    if (!medFilters.start || !medFilters.end) { message.warning('Seleccione un rango de fechas'); return; }
    const params = new URLSearchParams();
    params.set('start_date', moment(medFilters.start).format('YYYY-MM-DD 00:00'));
    params.set('end_date', moment(medFilters.end).format('YYYY-MM-DD 23:59'));
    if (medFilters.pacient) params.set('pacient', medFilters.pacient);
    if (medFilters.medical_insurance) params.set('medical_insurance', medFilters.medical_insurance);
    if (medGroupByMedication) params.set('group_by', 'medication');
    // Usar 'download=csv' en lugar de 'format=csv' para evitar conflictos con DRF
    params.set('download', 'csv');
    const url = `${config.api_url}/billing/medications?${params.toString()}`;
    const filename = `reporte_medicacion_${moment(medFilters.start).format('YYYYMMDD')}_${moment(medFilters.end).format('YYYYMMDD')}.csv`;
    fetch(url, { headers: { 'Authorization': `Token ${getToken()}` } })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.blob();
      })
      .then(blob => {
        const dlUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = dlUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(dlUrl);
      })
      .catch(() => message.error('No se pudo descargar el CSV'));
  };

  return (
    <>
      <ConfigProvider locale={esES}>
        <Layout style={{ minHeight: '100vh'}}>
          <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} className="no-print">
            <div className="logo" />
            <MyMenu active={active} />
          </Sider>
          <Layout className="site-layout">
            <Header />
            <Content style={{ margin: '0 16px' }}>
              <Breadcrumb style={{ position: 'relative', margin: '16px 0' }} className="no-print">
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Facturación</Breadcrumb.Item>
                <Breadcrumb.Item>Reporte de Medicamentos</Breadcrumb.Item>
              </Breadcrumb>

              <Card title="Reporte de Medicación" className="no-print">
                <Form layout="vertical">
                  <Row gutter={8}>
                    <Col span={8}>
                      <Form.Item label="Rango de fechas">
                        <RangePicker
                          value={[medFilters.start, medFilters.end]}
                          format={"DD/MM/YYYY"}
                          onChange={(vals) => {
                            setMedFilters({
                              ...medFilters,
                              start: vals && vals[0] ? vals[0] : null,
                              end: vals && vals[1] ? vals[1] : null,
                            });
                            setMedReportData([]);
                            setMedReportSummary(null);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Paciente (internación)">
                        <AutoComplete
                          style={{ width: '100%' }}
                          options={medPacientOptions}
                          onSearch={searchPacientsForMed}
                          value={medPacientText}
                          disabled={medGroupByMedication}
                          onSelect={(val, option) => {
                            setMedFilters({ ...medFilters, pacient: val });
                            setMedPacientText(option.label || '');
                            setMedReportData([]);
                            setMedReportSummary(null);
                          }}
                          onChange={(text) => {
                            setMedPacientText(text);
                            if (!text) {
                              setMedFilters({ ...medFilters, pacient: null });
                              setMedReportData([]);
                              setMedReportSummary(null);
                            }
                          }}
                          allowClear
                        >
                          <Input placeholder="Buscar paciente" />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Obra Social">
                        <Select
                          style={{ width: '100%' }}
                          allowClear
                          placeholder="Seleccione obra social"
                          onChange={(val) => {
                            setMedFilters({ ...medFilters, medical_insurance: val || null });
                            setMedReportData([]);
                            setMedReportSummary(null);
                          }}
                        >
                          {medicalInsurances.map(d => (
                            <Option key={d.value} value={d.value}>{d.text}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Form.Item label=" ">
                        <Checkbox
                          checked={medGroupByMedication}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setMedGroupByMedication(checked);
                            setMedReportData([]);
                            setMedReportSummary(null);
                            if (checked) {
                              setMedFilters(prev => ({ ...prev, pacient: null }));
                              setMedPacientText('');
                            }
                          }}
                        >Agrupar por medicamento</Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Button onClick={exportMedicationReport}>Exportar CSV</Button>
                    <Button type="primary" loading={medReportLoading} onClick={runMedicationReport}>Generar reporte</Button>
                  </div>
                </div>
                <div style={{ marginTop: 16 }}>
                  <Table
                    size="small"
                    rowKey={(r) => r.key}
                    columns={medGroupByMedication ? medColumnsByMedication : medColumnsPatient}
                    dataSource={medReportData}
                    loading={{ spinning: medReportLoading, tip: 'Generando reporte...' }}
                    pagination={false}
                  />
                </div>
                {medReportSummary && (
                  <div style={{ marginTop: 12, textAlign: 'right' }}>
                    <b>Total tomas:</b> {medReportSummary.total_intakes} &nbsp; | &nbsp; <b>Dosis total:</b> {medReportSummary.total_dose}
                  </div>
                )}
              </Card>
            </Content>
          </Layout>
        </Layout>
      </ConfigProvider>
    </>
  );
}

export default BillingMedications;
